import { Component, OnInit } from '@angular/core';
import { Meta, Title, DomSanitizer } from '@angular/platform-browser';
import { ServiceService } from 'src/app/service.service';
import { MetaServiceService } from '../../meta-service.service';

declare var $: any;

@Component({
    selector: 'app-temp-question',
    templateUrl: './temp-question.component.html',
    styleUrls: ['./temp-question.component.scss']
})
export class TempQuestionComponent implements OnInit {
    safeURL; //youTube Video URL //
    questiondisplay: any;
    selectedindexx = 0;
    
    constructor(
        private meta: Meta, 
        private title: Title, 
        private _sanitizer: DomSanitizer,
        public service: ServiceService,
        private metaService: MetaServiceService) {
      
     //  SEO Meta Description
        this.meta.addTags([
            { name: 'description', content: 'Home page of SEO friendly app' },
            { name: 'author', content: 'CViewSurvey' },
            { name: 'keywords', content: 'Angular, CViewSurvey' }
        ]);

        this.setTitle('CViewSurvey | Go on the Mobile');
        // End SEO Meta Description
        // You Tube Video Description
        this.safeURL = this._sanitizer.bypassSecurityTrustResourceUrl('https://www.youtube.com/embed/EsPq62yE3AE');
        // End You Tube Video Description
       }

    // SEO Page Title Description
    public setTitle(newTitle: string) {
        this.title.setTitle(newTitle);
    }
    // SEO Page Title Description 
    ngOnInit() {
        
        // for create canonical link 
        this.metaService.createCanonicalURL();

        // other
         let category_id = window.localStorage.getItem("category_id");
         let template_id = window.localStorage.getItem("selected_temp_id");
     
         
        this.Questionlist(template_id);
            $(document).ready(function () {
            $('.text-field-input').on('focus', function () {
                $(this).closest('.field-wrapper').addClass('focused');
            });

            $('.text-field-input').on('blur', function () {

                if ($(this).val() === '') {
                    $(this).closest('.field-wrapper').removeClass('focused');
                }
            });
          });
 
        
        }

      

        
     Questionlist(id) {
         this.service.template_question_list(id).subscribe((result: any[]) => {
           this.questiondisplay = result["data"];
        //   this.abc();
         });
         (error) => {
           console.log("no data found");
         };
       }

       indexchange(indexvalue){
      this.selectedindexx = indexvalue;
      }

    ngAfterViewinit(){
  
    }
    
}

